export class QRCodeModel {

    uid: string;
    ownerUid: string;
    ver: number;
    type: string;
    isSelected: boolean;
    
    constructor() { }
}
